import React from "react";
import { useTranslation } from "react-i18next";
import BackgroundE4Z from "../BackgroundE4Z";

export default function Finished(): JSX.Element {
  const { t } = useTranslation();

  return <BackgroundE4Z title={t("finished")} />;
}
